var CheckoutModel = (function (CheckoutSettings, CheckoutApiModel, ItemsCollection, ShipmentsCollection, PromoCodeModel, SummaryModel, VoucherCollection, Delivery, DeliveryOptions, AfterpayModel, OpenpayModel, _basketSettings) {

    return CheckoutApiModel.extend({

        defaults: {
            Delivery: new Delivery(),
            DeliveryOptions: new DeliveryOptions(),
            ItemList: new ItemsCollection(),
            ShipmentsList: new ShipmentsCollection(),
            PromoCode: new PromoCodeModel(),
            Summary: new SummaryModel(),
            Vouchers: new VoucherCollection(),
            Promocodes: new PromocodesCollection(),
            TermsOurPay: new TermsAndConditions(),
            ThreeDSecureRequired: false,
            IsOurPayThreeDSecureRequired: false,
            IsVCOThreeDSecureRequired: false,
            IsAgeRestricted: null,
            IsAgreeWithAgeRestricted: null,
            LastPaymentMethod: null,
            OurPayEnabled: false,
            DeliveryServicePackageDetail: new Backbone.Model(),
            IsEmpty: null,
            BasketMode: null,
            PhoneVerification: { IsRequired: false, Fields: { PhoneNumberFormat: {}, VerificationCodeFormat: {} } },
            AvailablePaymentOptions: new AvailablePaymentOptionsModel(),
            Afterpay: new AfterpayModel(),
            Openpay: new OpenpayModel(),
            ShowExtraMessage: false,
            OurPayMode: 0
        },

        initialize: function () {
            _.bindAll(this, '_update');
            _basketSettings.ready().done(_.bind(function () {
                this._onUpdateCheckout(this._update);
            }, this));
        },

        fetch: function (options) {
            // Save 'real' success, because Backbone overrides it and do set() in the wrapper, but it's not needed.
            if (options && options.success) {
                options._success = options.success;
            }
            return Backbone.Model.prototype.fetch.apply(this, arguments);
        },

        sync: function (method, model, options) {
            if (method === 'read') {
                var _isAuthorized = window.__isAuthorized__();
                var _isGuestCheckout = app.settings.get('UseGuestCheckout');
                var _orderXHR;

                if (!_isAuthorized && !_isGuestCheckout) {
                    $(function () {
                        landingFormShow().done(function () {
                            location.reload();
                        });
                    });
                    _orderXHR = PromiseUtil.rejected();
                } else {
                    var apiGetOrder = _.bind(_isGuestCheckout && !_isAuthorized ? api.getPublicCurrentOrder : api.getCurrentOrder, api);
                    _orderXHR = apiGetOrder({ imageSize: CheckoutSettings.imageSize, deliveryDetails: null }, { serverErrorHandleOption: api.RedirectionOptionsEnum.PopupMessage });
                }

                return _orderXHR.done(function (resp) {

                    CheckoutSettings.resolve(resp);

                    // Call saved success method. Needed for support fetch() method convention.
                    if (options._success) {
                        options._success(model, resp, options);
                    }

                    //model._update(resp);
                    model._updateCheckout(resp);
                    model.trigger('sync', model, resp, options);

                }).always(function () {
                    var apiCheckoutView = _.bind(!_isAuthorized ? api.checkoutPublicViewEvent : api.checkoutViewEvent, api);
                    apiCheckoutView();
                });
            } else {
                throw new Error('Method "' + method + '" is not implemented for this model');
            }
        },

        // TBD: Why we're need this if we have global pub/sub with _onUpdateCheckout()?
        _update: function (data) {
            data = data.Value;

            if (data && data.Shipments && !data.Shipments.length) {
                data.UseLocationDeliveryPriceSettings = false;
            }

            if (!data.IsEmpty && data.Items.length) {

                this.get('Delivery').update({
                    Current: this._parseCurrentAddress(data),
                    DecorationInfoList: data.DecorationInfoList,
                    isPickupPointsEnabled: data.PickupPointsEnabled,
                    BillingAddress: data.BillingAddress,
                    BasketMode: data.BasketMode || 0,
                    GiftMessage: data.GiftMessage || '',
                    GiftDateStr: data.GiftDateStr,
                    GiftOccasion: data.GiftOccasion || ''
                });

                this.get('DeliveryOptions').update(data);
                if (data.DeliveryServicePackageDetail) {
                    this.get('DeliveryServicePackageDetail').set(data.DeliveryServicePackageDetail);
                } else {
                    this.get('DeliveryServicePackageDetail').clear();
                }

                this.set('BasketMode', data.BasketMode);
                this.set('IsEmpty', false);
                this.set('OurPayEnabled', data.MyPayDetails.Enabled);
                this.get('ItemList').parseAndUpdate(data);
                this.get('ShipmentsList').parseAndUpdate(data);
                this.get('Vouchers').update(data.Vouchers);
                this.get('Promocodes').update(data.PromoCodeList);
                this.get('Summary').set(data.Summary);
                this.set('IsAgeRestricted', data.IsAgeRestricted || this.get('IsAgeRestricted')); //do not replace if not returned from PAPI
                this.set('LastPaymentMethod', data.LastPaymentMethod);
                this.set('ThreeDSecureRequired', data.ThreeDSecureRequired);
                this.set('IsOurPayThreeDSecureRequired', data.MyPayDetails && data.MyPayDetails.IsOurPayThreeDSecureRequired);
                this.set('IsVCOThreeDSecureRequired', data.VisaCheckout && data.VisaCheckout.Settings && data.VisaCheckout.Settings.IsThreeDSecureRequired);

                this.get('TermsOurPay').setState(data.MyPayDetails ? data.MyPayDetails.TermsAndConditions : false);
                this.set('PhoneVerification', data.PhoneVerification || this.get('PhoneVerification')); //do not replace if not returned

                this.set('AvailablePaymentOptions', data.AvailablePaymentOptions);
                this.get('Afterpay').set(data.Afterpay);
                this.get('Openpay').set(data.Openpay);
                this.set('ShowExtraMessage', data.MyPayDetails.ShowExtraMessage);
                this.set('OurPayMode', data.MyPayDetails.OurpayMode);
            } else {
                this.set('IsEmpty', true);
            }

            if (data.NotificationMessage) {
                alert(data.NotificationMessage);
            }
        },

        _parseCurrentAddress: function (data) {
            var result = data.DeliveryAddress || {};

            if (result.AdditionalData) {
                var additionalData = JSON.parse(result.AdditionalData);
                !additionalData.ID && !additionalData.GiftMessage && (result.AdditionalData = null);
            }
            if (additionalData && additionalData.GiftMessage) {
                result.GiftMessage = additionalData.GiftMessage;
            }

            return result;
        },

        IsAgreeWithAgeRestricted: function () {
            return !this.get('IsAgeRestricted') || !!this.get('IsAgreeWithAgeRestricted');
        }
    });

})(CheckoutSettings, CheckoutApiModel, ItemsCollection, ShipmentsCollection, PromoCodeModel, SummaryModel, VoucherCollection, Delivery, DeliveryOptions, AfterpayModel,OpenpayModel, app.settings);
